<template>
    <div>
        <div class="modal hide fade" id="modalProjectAttachmentModal" tabindex="-1" role="dialog" aria-labelledby="modalProjectAttachmentModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Attachment
                        </h4>
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                          <button type="button" @click="upload" class="btn btn-outline-primary" v-show="uploading">
                            Upload
                          </button>
                          <button class="btn btn-primary btn-block btn-login" type="button" disabled v-show="loading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>uploading...
                          </button>
                        </div>
                      </div>
                      <hr>
                      <ul>
                        <li v-for="a in getAttachment" :key="a.id">
                          <span @click="downloadAttachments(a.url, a.filename)" style="cursor: pointer; color: blue">{{ a.filename }}</span>
                          <span @click="removeAttachments(a.id)" class="ml-2"><i class="fa fa-times" aria-hidden="true"  style="cursor: pointer; color: red"></i></span>
                        </li>
                      </ul>
                      <!-- <pre>{{ project.attachments }}</pre> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary"  data-dismiss="modal">Close</button>
                        <!-- <button type="button" class="btn btn-success" >Save</button> -->
                    </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, projectUrl } from '../../config'
export default {
  name: 'ProjectAttachmentModal',
  props: ['project'],
  data () {
    return {
      file: null,
      loading: false,
      uploading: true
    }
  },
  methods: {
    downloadAttachments: function (id, filename) {
      Axios({
        url: projectUrl + '/attachment/' + id,
        method: 'GET',
        responseType: 'blob',
        headers: getHeader()
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    removeAttachments: function (id) {
      var attch = this.project.attachments.find(d => d.id === id)
      var index = this.project.attachments.findIndex(d => d.id === id)
      var obj = {
        id: attch.url,
        filename: attch.filename
      }
      console.log(projectUrl + '/attachment')
      if (attch.project_no === null) {
        Axios.delete(projectUrl + '/attachment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.data)
            this.project.attachments.splice(index, 1)
          })
          .catch(error => {
            console.log(error.response)
          })
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(projectUrl + '/attachment/', obj, { headers: getHeader() })
              .then(response => {
                console.log(response.data.datda)
                this.project.attachments.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },
    upload: function () {
      this.loading = true
      this.uploading = false
      const formData = new FormData()
      formData.append('file', this.file)
      if (this.project.project_no) {
        formData.append('project_no', this.project.project_no)
      }
      console.log(formData)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      console.log(projectUrl + '/attachment')
      Axios.post(projectUrl + '/attachment', formData, { headers: newObj })
        .then(response => {
          console.log(response.data.data)
          const data = response.data.data
          var newId = null
          if (data.id === null) {
            newId = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
          } else {
            newId = data.id
          }
          this.project.attachments.push({
            id: newId,
            project_no: data.project_no ? data.project_no : null,
            filename: data.filename,
            url: data.url,
            extension: data.extension,
            real_path: data.real_path,
            size: data.size,
            mime_type: data.mime_type,
            upload_date: data.upload_date,
            queue: null
          })
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            'Failed to upload',
            'error'
          )
        })
      this.loading = false
      this.uploading = true
    }
  },
  computed: {
    getAttachment: function () {
      return this.project.attachments.filter(d => d.id !== null)
    }
  }
}
</script>
